export default __webpack_public_path__ + "static/media/modal-icon-error.605080a4.svg";